
<template>
  <transition name="fade" @closesModal="supportOldDetailModal = false" @update="update = true">
    <SupportOld2024Detail :detailsSupportOldSeq="detailsSupportOldSeq" :update="update" v-if="supportOldDetailModal" />
  </transition>
  <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"> 
    <h1 class="h2">기술지원 내역-2024</h1>
  </div>

  <!-- 검색 조건 -->
  <div class="container" v-if="isMobile == false">  
    <input v-model="searchKeywordCompany" class="form-control" type="text" placeholder="고객사명" @keyup.enter="changePage(1, this.pagination.pageSize)" />  
    <input v-model="searchKeywordProject" class="form-control" type="text" placeholder="프로젝트명" @keyup.enter="changePage(1, this.pagination.pageSize)"  />  
    <input v-model="searchKeywordSupportName" class="form-control" type="text" placeholder="작업자" @keyup.enter="changePage(1, this.pagination.pageSize)"  style="max-width: 100px;"/>        
    <Dropdown v-model="searchKeywordSupportCategory" editable  :options="supportCategorys" optionLabel="label" placeholder="지원방법" class="w-full md:w-14rem" style="min-width: 140px;"/>  
    <Dropdown v-model="searchKeywordSupportCategoryDetail" editable  :options="supportCategoryDetails" optionLabel="label" placeholder="지원구분" class="w-full md:w-14rem" style="min-width: 140px;"/>  
    <Calendar v-model="searchDate" selectionMode="range" :manualInput="false" dateFormat="yy/mm/dd" showButtonBar showIcon @show="adjustZIndex" @update:model-value="updateCal" v-tooltip.top="{ value: t_SearchDate, autoHide: false }" style="width: 50%;"/>  
    <input v-model="searchKeywordReqResDetails" class="form-control" type="text" placeholder="요청 / 지원 내용" @keyup.enter="changePage(1, this.pagination.pageSize)"  />  
    <Button class="pi pi-search" @click="changePage(1, this.pagination.pageSize)" @mouseover="setHoverText('검색')" @mouseout="clearHoverText" :title="hoverText"></Button>		
    <Button class="pi pi-times-circle" severity="success" @click="unsetSearchData" @mouseover="setHoverText('검색 초기화')" @mouseout="clearHoverText" :title="hoverText"></Button>
    <Button @click="exportXls($event)" style="display:inline-flex; justify-content:center; background:#ffffff; border:1px solid #939599; height:8%; width:8%;">
      <img src="@/assets/excel.svg" alt="Excel Icon" style="width: 25px; height: 25px;" />
    </Button>
  </div>

  <!-- 검색 조건 모바일 -->
  <!-- <div class="container d-flex" v-if="isMobile == true" >
    <div class="d-flex" style="width:100%;">
	  <input v-model="searchKeyword" class="form-control" type="text" placeholder="프로젝트 / 고객사명 / IP / 일련번호"  @keyup.enter="changePage(1, this.pagination.pageSize)" />    
      <Button class="pi pi-search" @click="changePage(1, this.pagination.pageSize)" @mouseover="setHoverText('검색')" @mouseout="clearHoverText" :title="hoverText"></Button>		
    </div>
  </div> -->

  <!-- 본문 -->
  <div class="container" v-if="isMobile == false">	    
	  <table class="table table-bordered table-hover caption-top">
	    <thead class="table-light">
	      <tr class="table-primary">
	        <th scope="col" v-for="item in header" :key="item" class="center">
	          {{ item }}
          </th>
        </tr>
      </thead>
      <tbody class="table-group-divider">
        <tr v-for="(row, i) in supportOld" :key="i"  >
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.companyName.length > 8 ? row.companyName.substring(0,8) + '...' : row.companyName }}</td>
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.projectName.length > 16 ? row.projectName.substring(0,16) + '...' : row.projectName }}</td>
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.visitDate }}</td>
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.supportCategory }}</td>
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.supportCategoryDetail }}</td>
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.supportProdName }}</td>
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.serverType }}</td>
          <td class="center" @click="popupDetailModal(row)" style="cursor: pointer; text-overflow:ellipsis;">{{ row.supportName }}</td>         
        </tr>
      </tbody>
    </table>
  </div> 

  <!-- 본문 모바일 Start -->
  <!-- <div class="container" v-if="isMobile == true">
  	<Accordion class="accordion-custom" :activeIndex="0">
	    <AccordionTab v-for="(row, i) in supportOld" :key="i">        
	    	<template #header>
          <span>{{row.companyName + ' - ' + row.projectName}}
            <br/><span v-if="row.ipAddress !== null">(<span v-html="row.ipAddress !== null ? row.ipAddress.replaceAll(',', ',<br/>') : '-'"></span>)</span>
          </span>
        </template>
        <p>{{ header[2] }} : {{ row.licenseSerialNo }}</p>
        <p>{{ header[3] }} : {{ row.serverType }}</p>
        <p>{{ header[4] }} : {{ row.startDate }}</p>
        <p>{{ header[5] }} : {{ row.endDate }}</p>
        <p>{{ header[6] }} : {{ row.cpuInfo }}</p>
        <p>{{ header[7] }} : <span v-html="row.ipAddress !== null ? row.ipAddress.replaceAll(',', ',<br/>') : '-'"></span></p>
        <p>발급제품 : {{ row.r3 == 1 ? ' R3' : '' }}
          {{ row.r4 == 1 ? ' R4' : '' }}
          {{ row.r5 == 1 ? ' R5' : '' }}
          {{ row.e25 == 1 ? ' E25' : '' }}
          {{ row.e4 == 1 ? ' E4' : '' }}
          {{ row.e5 == 1 ? ' E5' : '' }}</p>	                  
        <p>{{ header[14] }} : {{ row.modifierName }}</p>
        <p>등록날짜 : {{ row.registerDate }}</p>
        <p style="overflow-wrap: break-word;">KEY : {{ row.key }}</p>
	    </AccordionTab>
	  </Accordion>
  </div> -->
  <!-- 본문 모바일 End -->

  <div class="container">
	  <Pagination :pagination="pagination" @page-change="changePage" v-if="isMobile == false"></Pagination>
	  <mPagination :pagination="pagination" @page-change="changePage" v-if="isMobile == true"></mPagination>
  </div>
</template>

<script>
import SupportOld2024Detail from './SupportOld2024Detail.vue'
import Pagination from '@/components/Common/ClipPagination.vue'
import mPagination from '@/components/Common/mClipPagination.vue'
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'

export default {
  name: 'SupportMain',
  data() {
    return {
      supportOldDetailModal: false,
      supportOld: {},      
      header: ["고객사","프로젝트","지원일자","지원방법","지원구분","제품","서버구분","작업자"],      
      update: false,
      searchKeywordProject: '',
      searchKeywordCompany: '',
      searchKeywordSupportCategory: '',
      searchKeywordSupportCategoryDetail: '',
      searchDate: null,
      t_SearchDate: '날짜 선택',
      searchKeyword: '',
      detailsSupportOldSeq: '',
      currentPage: 1,        // 현재 페이지
      itemsPerPage: 10,      // 페이지당 항목 수
      total: 0,      // 페이지당 항목 수
      pagination: {
    		endRow: 0,
		    hasNextPage: false,
		    hasPreviousPage: false,
		    isFirstPage: true,
		    isLastPage: true,
		    navigateFirstPage: 0,
		    navigateLastPage: 0,
		    navigatePages: 10,
		    navigatepageNums: [],
		    nextPage: 0,
		    pageNum: 1,
		    pageSize: this.isMobile ? 5 : 10,
		    pages: 0,
		    prePage: 0,
		    size: 0,
		    startRow: 0,
		    total: 0
    	},      
      hoverText: '',
      supportCategorys: {},
      supportCategoryDetails: {},
    };
  },
  props: {
  	isMobile: Boolean,
  },
  components: {
    SupportOld2024Detail,
    Pagination,
    mPagination,
  },
  created() {      
    this.$code(["SUPPORT_CATEGORY_DETAIL", "SUPPORT_CATEGORY"], false,
      function(result, i){
            i.supportCategorys = result.supportCategory;
            i.supportCategoryDetails = result.supportCategoryDetail;
            i.supportCategoryDetails = i.supportCategoryDetails.map(item => item.label === "기술지원" ? { ...item, label: "지원" } : item );            
          },
          function(e, i){
            console.log(e);
          }
    );
    this.$calendar();
  }, 
  watch: {
    update(update) {
      if (update == true) {
        //window.location.reload(true);
        var pageSize = this.isMobile ? 5 : 10;
        this.changePage(this.currentPage, pageSize);
        this.update = false;
      }
    }
  },
  computed: {
  },
  methods: {
    // 페이지 변경 시 호출될 함수
    changePage(newPage, pageSize) {
      this.currentPage = newPage;
      var paramData = {
    	"pageNum": newPage,
      "pageSize": pageSize,
      "searchKeyword": this.searchKeyword,
      "searchKeywordProject": this.searchKeywordProject.projectName != undefined ? this.searchKeywordProject.projectName : this.searchKeywordProject != "" ? this.searchKeywordProject : "",
      "searchKeywordCompany": this.searchKeywordCompany.companyName != undefined ? this.searchKeywordCompany.companyName : this.searchKeywordCompany != "" ? this.searchKeywordCompany : "",
      "searchKeywordSupportName": this.searchKeywordSupportName != undefined ? this.searchKeywordSupportName : "",
      "searchKeywordSupportCategory": this.searchKeywordSupportCategory.label != undefined ? this.searchKeywordSupportCategory.label : "",
      "searchKeywordSupportCategoryDetail": this.searchKeywordSupportCategoryDetail.label != undefined ? this.searchKeywordSupportCategoryDetail.label : "",
      "searchKeywordReqResDetails": this.searchKeywordReqResDetails != undefined ? this.searchKeywordReqResDetails : "",      
      "startDate": this.searchDate != null ? this.$simpleDateTimeFormat(this.searchDate[0], "yyyy-MM-dd") : "",
      "endDate":this.searchDate != null && this.searchDate[1] != null ? this.$simpleDateTimeFormat(this.searchDate[1], "yyyy-MM-dd") : "", 
	    };      
    this.$get('/biz/supportold/2024/list', {
	            	params: paramData
	       		 },
                function(response, i){                  
                	i.supportOld = response.data.pagination.list;   //기존데이터에 추가
                	i.pagination = response.data.pagination;
                  i.pagination.total == 0 ? i.$messageShow('조회된 값이 없습니다.', 'warn') : "";
                },
                function(e, i){
                	console.log(e);
                }
     );
     
    },
    popupDetailModal(row){
    	this.supportOldDetailModal = true;
    	this.detailsSupportOldSeq = row.seq;
    },    
    unsetSearchData(){    	
	    this.searchKeywordProject = "";
	    this.searchKeywordCompany = "";	    
      this.searchKeywordSupportName = "";
      this.searchDate= null;
      this.searchKeywordReqResDetails = "";
      this.t_SearchDate = "날짜 선택";
      this.searchKeywordSupportCategory = "";
      this.searchKeywordSupportCategoryDetail = "";
  },
    setHoverText(text) {
      this.hoverText = text;
    },
    clearHoverText() {
      this.hoverText = '';
    },
    exportXls() {
            var paramData = {
              "pageNum": 1,
              "pageSize": 1000000,
              "searchKeyword": this.searchKeyword,
              "searchKeywordProject": this.searchKeywordProject != undefined ? this.searchKeywordProject : "",
              "searchKeywordCompany": this.searchKeywordCompany != undefined ? this.searchKeywordCompany : "",
            };

            this.$get('/biz/supportold/2024/list', {
              params: paramData
            },
            (response) => {
              const data = response.data.pagination.list;
              const worksheet = XLSX.utils.json_to_sheet(JSON.parse(JSON.stringify(data)));
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

              const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
              const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

              saveAs(dataBlob, '기술지원2024_내역.xlsx');
            },
            (error) => {
              console.log(error);
            });
    },
    updateCal(value){    
      if(value == null) {
        this.searchDate = null;
        this.t_SearchDate = null;
      }
      else if(value[1] == null){
        this.t_SearchDate = this.$simpleDateTimeFormat(value[0], "yyyy-MM-dd");
      } else {
        this.t_SearchDate = "시작일 : "+this.$simpleDateTimeFormat(value[0], "yyyy-MM-dd") + '\n' + "종료일 : "+this.$simpleDateTimeFormat(value[1], "yyyy-MM-dd"); 
      }
    },
    adjustZIndex() {
      this.$nextTick(() => {
        setTimeout(() => {
          const calendarPopup = document.querySelector("[id^='pv_id_'].p-datepicker");  
          if (calendarPopup) {          
            calendarPopup.style.zIndex = "3103";  
          } 
        }, 10);
      });
    }
  },
};
</script>

<style lang="css" scoped>
.container {
  display: flex;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 0px;
  justify-content: center
}
.container > * {
  margin-right: 10px;
  font-size: 15px;
}
.container > *:last-child {
  margin-right: 0;
}
.container .selects {
  display: flex;
}
.container .selects select {
  width: 120px;
  margin-right: 10px;
}
.container .selects select:last-child {
  margin-right: 0;
}

.center {
  text-align: center;
}
.container .btn {
  width: 120px;
  height: 50px;
  font-weight: 700;
  flex-shrink: 0;
}
@media only screen and (max-width: 480px) {
	.container {
	  display: block;
	}
	.selects {
	  margin-top: 10px;
	}
	.btn {
	  margin-top: 10px;
	}
}

th{
  text-align: center;
}

.pi{
  min-width: 56px;
  width: 56px;
  min-height: 50px;
  height: 50px;
}
</style>